/*
 * File: cell-datetime.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import {
    BaseTableBodyCell,
    ITableBodyCellData,
    defaultTableBodyCellData,
} from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { DateHelper } from "@root/core";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellDatetime extends BaseTableBodyCell {
    @Prop({ type: Date, required: false })
    declare value: Date;

    @Prop({ type: Object, required: false })
    declare data: (Intl.DateTimeFormatOptions & ITableBodyCellData) | undefined;

    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...this.data,
        };
    }

    get localeString() {
        if (this.value == null) return this.$_(this.mergedData["text-empty"]);
        return DateHelper.toString(this.value, this.mergedData);
    }
}
